import { render, staticRenderFns } from "./AllowanceSummary.vue?vue&type=template&id=5fae835e&scoped=true"
import script from "./AllowanceSummary.vue?vue&type=script&lang=js"
export * from "./AllowanceSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fae835e",
  null
  
)

export default component.exports